import { render, staticRenderFns } from "./MenuCollapseItemHeader.vue?vue&type=template&id=10422d6e&"
import script from "./MenuCollapseItemHeader.vue?vue&type=script&lang=js&"
export * from "./MenuCollapseItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports